import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageConfig from '@/component/layout/PageConfig.tsx';
import { equalString } from '@/util/strings.ts';
import NotificationLayout from '@/pages/notification/layout/NotificationLayout.tsx';
import NotificationEmergencyContainer from '@/pages/notification/NotificationEmergencyContainer.tsx';
import NotificationBioContainer from '@/pages/notification/NotificationBioContainer.tsx';
import NotificationFalldetectionContainer from '@/pages/notification/NotificationFalldetectionContainer.tsx';

const NotificationPage: React.FunctionComponent = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // 기존 탭이 있다면 유지, 없으면 'sos'로 설정
    useEffect(() => {
        if (!searchParams.get('tab')) {
            setSearchParams({ tab: 'sos' }, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    const tab = searchParams.get('tab') || 'sos';

    return (
        <PageConfig showTopNav={true} showFooter={true}>
            <NotificationLayout>
                {equalString(tab, 'sos') && <NotificationEmergencyContainer />}
                {equalString(tab, 'bio') && <NotificationBioContainer />}
                {equalString(tab, 'falldetection') && <NotificationFalldetectionContainer />}
            </NotificationLayout>
        </PageConfig>
    );
}

export default NotificationPage;
